import { useNotify, useTranslate, useUpdate } from "ra-core";

import { trackingStatusLabelKey } from "@/components/market-intel/labels";
import type {
  MarketCompetitor,
  TrackingStatus,
} from "@/components/market-intel/types";

import { trackingStatusPatch } from "./competitors";

/** Optimistic quick change of a competitor's tracking status. */
export const useTrackingStatusChange = () => {
  const [update] = useUpdate<MarketCompetitor>();
  const notify = useNotify();
  const translate = useTranslate();
  return (competitor: MarketCompetitor, status: TrackingStatus) => {
    const patch = trackingStatusPatch(competitor, status);
    if (!patch) return;
    update("market_competitors", patch, {
      mutationMode: "optimistic",
      onSuccess: () =>
        notify("market.competitors.status_updated", {
          type: "success",
          messageArgs: { status: translate(trackingStatusLabelKey(status)) },
        }),
      onError: () => notify("market.competitors.error", { type: "error" }),
    });
  };
};
